import QAndASellerContainer from './QAndASellerContainer.component';

export default QAndASellerContainer;